<template>
    <div class="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end sm:pt-20 z-50">
        <toast-notification :notification="notification"
                            v-for="(notification, index) in notifications"
                            :key="index"
                            @destroy="removeNotification(index)"
        ></toast-notification>
    </div>
</template>

<script>
    import ToastNotification from "./Notification";

    export default {
        data() {
            return {
                notifications: [],
            }
        },

        components: { ToastNotification },

        mounted() {
            bus.$on('create-toast', toast => {
                toast.destroy = false;
                this.notifications.push(toast);
            });
        },

        methods: {
            removeNotification(index) {
                this.notifications.splice(index, 1);
            }
        }
    }
</script>
